import { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from '../pages/Home';
import Pharmacy from '../pages/Pharmacy';
import ScrollProgressBar from '../components/common/ScrollProgressBar';
import { usePageMetadata } from '../hooks/usePageMetadata';

const ScrollToTopOnRoute = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
};

const PageMetadataOnRoute = () => {
  usePageMetadata();
  return null;
};

const Router = () => {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-[#0D7893]/20 border-t-[#0D7893] rounded-full animate-spin" />
            <span className="text-sm font-semibold text-slate-500">
              Loading Divine Health Suite...
            </span>
          </div>
        </div>
      }
    >
      <ScrollToTopOnRoute />
      <PageMetadataOnRoute />
      <ScrollProgressBar />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pharmacy" element={<Pharmacy />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </Suspense>
  );
};

export default Router;
